import { Popup } from "devextreme-react";
import { Table2 } from "../../../../../components/Table2/Table2";
import { useEffect, useState } from "react";
import { ApiError } from "../../../../Error/ApiError";
import { VoidPopup } from "../VoidPopup";
import { ReactComponent as AddIcon } from "../../../../../assets/images/icons/add.svg";
import { Navigate, useNavigate } from "react-router-dom";
import { logOut } from "../../../../../components/Logout";
import { handleGetLocal } from "../../../../../services/auth-service";
import axios from "axios";
import { EMPriod } from "../../EM/EmPopup/EMPriod";
import { setEmOverviewTableExpand } from "../../../../../reducer/AdminReadReducer";
import { setEmExpnadTableData } from "../../EM/Data";
import ConfirmPopup from "../../../../Monitoring/Popups/ConfirmPopup";

const Tablecoloum = [
  { title: "", moreoption: true, customwidth: "50px" },
  {
    title: "Start Date", date: true,
  },
  { title: "End Date", date: true, },
  {
    title: "Monitoring Type"
  },
  { title: "Active?", bool: true },
  {
    title: "Daily Rate",
  },
  {
    title: "Duration",
  },
  {
    title: "End Reason",
  },
  {
    title: "Voided", customwidth: "60px",
    bool: true,
  },
];

const setEmTableDatas = (data) => {
  const arr = [];
  data.map((val, i) => {
    arr.push({
      "Start Date": val?.dStart,
      "End Date": val?.dEnd,
      "Monitoring Type": val?.sEM_TYPE,
      "Active?": val?.bIsActive,
      "Daily Rate": val?.fDailyRate,
      "Duration": val?.iDuration,
      "End Reason": val?.sEndReason,
      "Voided": val?.bVoid,
      gEmPeriodId: val?.gEmPeriodId,
      "userinfo": { gDocketId: val?.gDocketId },
      gDocketId: val?.gDocketId,
      "EM Type":val?.sEmType,
      gEmTypeId:val?.gEmTypeId,
      gEmEndReasonId:val?.gEmEndReasonId,
      Comment:val?.sComment,
      sOffenderNumber:val?.sOffenderNumber,
      sDocketNumberCourtCounts:val?.sDocketNumberCourtCounts,
      val,
      ID: i,
    });
  });
  return arr;
};

// const AddRevocations = ({
//   AddRevocationspopup,
//   setAddRevocationspopup,
//   docketDropdownData,
//   dropdownData,
//   toastConfig,
//   setToastConfig,
//   getRevocationsDataApi,
//   dockertDetail,
//   setReset,
//   reset,
//   GoToRevocationDocketDisable,
// }) => {
//   return (
//     <Popup
//       visible={AddRevocationspopup}
//       onHiding={() => {
//         setReset(!reset);
//         setAddRevocationspopup(false);
//       }}
//       showTitle={false}
//       width={730}
//       height={620}
//       showCloseButton={true}
//       hideOnOutsideClick={false}
//     >
//       <AddRevocationsPopup
//         AddRevocationspopup={AddRevocationspopup}
//         setAddRevocationspopup={setAddRevocationspopup}
//         docketDropdownData={docketDropdownData}
//         reset={reset}
//         setReset={setReset}
//         dropdownData={dropdownData}
//         toastConfig={toastConfig}
//         setToastConfig={setToastConfig}
//         getRevocationsDataApi={getRevocationsDataApi}
//         dockertDetail={dockertDetail}
//         GoToRevocationDocketDisable={GoToRevocationDocketDisable}
//       />
//     </Popup>
//   );
// };

// const EditRevocations = ({
//   editRevocationspopup,
//   seteditRevocationspopup,
//   docketDropdownData,
//   dropdownData,
//   toastConfig,
//   setToastConfig,
//   getRevocationsDataApi,
//   getEDitdataRevocations,
//   GoToRevocationDocketDisable,
// }) => {
//   const [reset, setReset] = useState(false);

//   if (!getEDitdataRevocations) {
//     return;
//   }

//   return (
//     <Popup
//       visible={editRevocationspopup}
//       onHiding={() => {
//         setReset(!reset);
//         seteditRevocationspopup(false);
//       }}
//       showTitle={false}
//       width={730}
//       height={620}
//       showCloseButton={true}
//       hideOnOutsideClick={false}
//     >
//       <EditRevocationsPopup
//         editRevocationspopup={editRevocationspopup}
//         seteditRevocationspopup={seteditRevocationspopup}
//         docketDropdownData={docketDropdownData}
//         reset={reset}
//         setReset={setReset}
//         dropdownData={dropdownData}
//         toastConfig={toastConfig}
//         setToastConfig={setToastConfig}
//         getRevocationsDataApi={getRevocationsDataApi}
//         getEDitdataRevocations={getEDitdataRevocations}
//         GoToRevocationDocketDisable={GoToRevocationDocketDisable}
//       />
//     </Popup>
//   );
// };

// const Void = ({
//   setVoidPopup,
//   voidPopup,
//   toastConfig,
//   setToastConfig,
//   setLoad,
//   getTollingDataApi,
//   userinfo,
//   getData,
// }) => {
//   return (
//     <Popup
//       visible={getData?.gRevocationId && voidPopup}
//       onHiding={() => {
//         setVoidPopup(false);
//       }}
//       showTitle={false}
//       width={800}
//       height={450}
//       showCloseButton={true}
//       hideOnOutsideClick={false}
//     >
//       <VoidPopup
//         setVoidPopup={setVoidPopup}
//         voidHeading="Void Revocation"
//         voidSubHeading="Void Revocation"
//         setLoad={setLoad}
//         toastConfig={toastConfig}
//         setToastConfig={setToastConfig}
//         filedId={getData?.gRevocationId}
//         fieldName="recordId"
//         apiURl="/revocation/void-revocation"
//         refreshApi={getTollingDataApi}
//         // Tollingheading={`Void Tolling ${getData?.Start} - ${getData?.End}`}
//         userinfo={userinfo}
//         comment="Comments"
//       />
//     </Popup>
//   );
// };

export const EMPeriod = ({
  Docketid,
}) => {
  const [getEDitdataEmPeriod, setgetEDitdataEmPeriod] = useState({});
  const [EMPriodpopshow, setEMPriodpopshow] = useState(false);
  const [EMPriodeditpopshow, setEMPriodeditpopshow] = useState(false);
  const [emperiodconfirmPopup, setEMPeriodConfirmPopup] = useState(false);
  const [emTableData, setEmTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "",
    message: "",
  });
  const pathname = handleGetLocal("pathURL");
  const Navigate = useNavigate();

  const getEmPeriodApi = async () => {
    if (!Docketid) {
      return;
    }
    setLoading(true);
    await axios
      .get(`${process.env.REACT_APP_API_URL}/api/em/get-em-period?gDocketId=${Docketid}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${pathname}`,
        },
      })
      .then((val) => {
        setLoading(false);
        if (val?.data?.isSuccess) {
          setEmTableData(setEmTableDatas(val?.data?.data));
        }
      })
      .catch((val) => {
        if (!val?.response) {
          Navigate(`/error/500`);
        } else if (val?.response?.status === 401) {
          logOut();
        }
      });
  };

  useEffect(() => {
    getEmPeriodApi();
  }, []);

  return (
    <>
      <Popup
        visible={EMPriodpopshow}
        onHiding={() => {
          setEMPriodpopshow(false);
        }}
        showTitle={false}
        width={730}
        height={650}
        showCloseButton={true}
        hideOnOutsideClick={false}
      >
        <EMPriod
          EMPriodpopshow={EMPriodpopshow}
          setEMPriodpopshow={setEMPriodpopshow}
          rowleveldata={getEDitdataEmPeriod}
          getEmDataApi={getEmPeriodApi}
          setToastConfig={setToastConfig}
          toastConfig={toastConfig}
          emPopupType={"Add"}
        // parentRowData={parentRowData}
        />
      </Popup>
      <Popup
        visible={EMPriodeditpopshow}
        onHiding={() => {
          setEMPriodeditpopshow(false);
        }}
        showTitle={false}
        width={730}
        height={650}
        showCloseButton={true}
        hideOnOutsideClick={false}
      >
        <EMPriod
          EMPriodpopshow={EMPriodeditpopshow}
          setEMPriodpopshow={setEMPriodeditpopshow}
          rowleveldata={getEDitdataEmPeriod}
          getEmDataApi={getEmPeriodApi}
          setToastConfig={setToastConfig}
          toastConfig={toastConfig}
          emPopupType={"Edit"}
        // parentRowData={parentRowData}
        />
      </Popup>
      <Popup
        visible={emperiodconfirmPopup}
        onHiding={() => {
          setEMPeriodConfirmPopup(false);
        }}
        showTitle={false}
        width={450}
        height={170}
        showCloseButton={true}
        hideOnOutsideClick={false}
      >
        <ConfirmPopup
          confirmPopup={emperiodconfirmPopup}
          setConfirmPopup={setEMPeriodConfirmPopup}
          setLoading={setLoading}
          navigate={Navigate}
          setToastConfig={setToastConfig}
          toastConfig={toastConfig}
          refreshApi={getEmPeriodApi}
          apiURl={`api/em/void-emperiod?GEmPeriodId=${getEDitdataEmPeriod?.gEmPeriodId}`}
          typePara={"Void"}
        />
      </Popup>
      <div style={{ marginTop: "1%" }}>
        <div className="Revocationstable">
          <Table2
            Tablecoloum={Tablecoloum}
            tableRow={emTableData}
            editTable={false}
            load={false}
            coloumWidthText={"Monitoring Type"}
            height={"auto"}
            mandatoryColoum={"Duration"}
            showTotalBlock={false}
            EMPeriodcontextmenu={true}
            setgetEDitdataEmPeriod={setgetEDitdataEmPeriod}
            setEMPriodpopshow={setEMPriodpopshow}
            setVoideFalse={true}
            setEMPriodeditpopshow={setEMPriodeditpopshow}
            setEMPeriodConfirmPopup={setEMPeriodConfirmPopup}
          />
        </div>
      </div>

    </>
  );
};
